namespace Matrix.Data {
    export class SecurityRelationshipColumns {
        static columnsKey = 'Matrix.Data.Columns.SecurityRelationshipColumns';
    }
}
